/**
 * Expand/contract read for a renamed STORED field (restaurant → location
 * rename, Phase 0 and Phase 6). Docs written before the rename carry only the
 * legacy name; the new name wins when both exist. A disagreement means a stale
 * writer is still writing the old name after backfill — it is reported, never
 * silently resolved the other way.
 */
const warned = new Set<string>();

export function readRenamed<T>(
  doc: Record<string, unknown> | undefined,
  next: string,
  legacy: string,
  where: string,
  warn: (msg: string, ctx: object) => void = (m, c) => console.warn(m, c),
): T | undefined {
  if (!doc) return undefined;
  const n = doc[next];
  const l = doc[legacy];
  if (n !== undefined && l !== undefined && JSON.stringify(n) !== JSON.stringify(l)) {
    const key = `${where}|${next}`;
    if (!warned.has(key)) {
      warned.add(key);
      warn('renamed field disagrees', { where, next, legacy });
    }
  }
  return (n !== undefined ? n : l) as T | undefined;
}
